//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getAction } from '@/api/manage';
import DataLogCompareModal from "./DataLogCompareModal";
export default {
  name: 'DataLogModal',
  components: {
    DataLogCompareModal: DataLogCompareModal
  },
  dataId1: '',
  dataId2: '',
  dataTable1: '',
  dataID3: '',
  data: function data() {
    return {
      modalWidth: 700,
      modaltoggleFlag: true,
      confirmDirty: false,
      title: "操作",
      visible: false,
      model: {},
      confirmLoading: false,
      headers: {},
      form: this.$form.createForm(this),
      url: {
        queryDataVerListUrl: "/sys/dataLog/queryDataVerList"
      },
      DataVersionList: []
    };
  },
  created: function created() {},
  methods: {
    addModal: function addModal(records) {
      var _this = this;

      var dataTable = records[0].dataTable;
      var dataId = records[0].dataId;
      var dataVersion1 = records[0].dataVersion;
      var dataVersion2 = records[1].dataVersion;
      this.dataId1 = records[0].id;
      this.dataId2 = records[1].id;
      this.dataTable1 = records[0].dataTable;
      this.dataID3 = records[0].dataId;
      this.initDataVersionList();
      this.form.resetFields();
      this.visible = true;
      this.$nextTick(function () {
        _this.form.setFieldsValue({
          dataTale: dataTable,
          dataId: dataId,
          dataVersion1: dataVersion1,
          dataVersion2: dataVersion2
        });
      });
    },
    handleOk: function handleOk() {
      this.close();
      this.$refs.modal.compareModal(this.dataId1, this.dataId2);
      this.$refs.modal.title = "数据比较";
    },
    handleCancel: function handleCancel() {
      this.close();
    },
    handleSubmit: function handleSubmit() {},
    close: function close() {
      this.$emit('close');
      this.visible = false;
      this.disableSubmit = false;
    },
    modalFormOk: function modalFormOk() {},
    initDataVersionList: function initDataVersionList() {
      var _this2 = this;

      var that = this;
      getAction(that.url.queryDataVerListUrl, {
        dataTable: this.dataTable1,
        dataId: this.dataID3
      }).then(function (res) {
        if (res.success) {
          _this2.DataVersionList = res.result;
        } else {
          _this2.DataVersionList = [];
          _this2.dataId1 = '', _this2.dataId2 = '', console.log(res.message);
        }
      });
    },
    handleChange1: function handleChange1(value) {
      this.dataId1 = value;
    },
    handleChange2: function handleChange2(value) {
      this.dataId2 = value;
    },
    handleTableBlur: function handleTableBlur(e) {
      this.dataTable1 = e.target.value;
      this.initDataVersionList();
    },
    handleIdBlur: function handleIdBlur(e) {
      this.dataID3 = e.target.value;
      this.initDataVersionList();
    }
  }
};